import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MembershipPlanCard = ({ plan, isSelected, onSelect, isPopular, disabled }) => {
  return (
    <div
      className={`
        relative bg-card border-2 rounded-xl p-6 transition-smooth hover-lift
        ${isSelected 
          ? 'border-accent shadow-lg' 
          : 'border-border hover:border-accent/50'
        }
        ${disabled ? 'opacity-60 pointer-events-none' : ''}
      `}
    >
      {isPopular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-accent text-accent-foreground rounded-full text-xs font-bold caption">
          MOST POPULAR
        </div>
      )}
      <div className="text-center mb-6">
        <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2">
          {plan?.name}
        </h3>
        <div className="flex items-baseline justify-center gap-1">
          <span className="text-3xl md:text-4xl font-bold text-primary data-text">
            ${plan?.price}
          </span>
          <span className="text-sm text-muted-foreground">/{plan?.period}</span>
        </div>
      </div>
      <ul className="space-y-3 mb-6">
        {plan?.features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <Icon 
              name={feature?.included ? "Check" : "X"} 
              size={20} 
              color={feature?.included ? "var(--color-success)" : "var(--color-muted-foreground)"}
              strokeWidth={2.5}
              className="flex-shrink-0 mt-0.5"
            />
            <span className={`text-sm ${feature?.included ? 'text-foreground' : 'text-muted-foreground line-through'}`}>
              {feature?.text}
            </span>
          </li>
        ))}
      </ul>
      <Button
        variant={isSelected ? "default" : "outline"}
        fullWidth
        onClick={onSelect}
        iconName={isSelected ? "Check" : "ArrowRight"}
        iconPosition="right"
        disabled={disabled}
      >
        {isSelected ? 'Selected' : 'Select Plan'}
      </Button>
    </div>
  );
};

export default MembershipPlanCard;